// Installs from before the /api runtime cache was removed still hold one, with
// whoever last used the phone's responses in it. Cleared at every start and at
// logout, so a phone where nobody logs out does not keep them.
export function clearStaleApiCache(): void {
  try {
    void caches?.delete("api-cache").catch(() => {});
  } catch {
    // no Cache API (insecure context, old browser) — nothing to clear
  }
}
